import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  HostBinding,
} from '@angular/core';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { IS_MOBILE_TOKEN } from '@anecdotes/design-system/injection-tokens';
import { RequirementResponse } from '@anecdotes/shared-trust-center';

@Component({
  selector: 'app-controls-label',
  templateUrl: './controls-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ControlsLabelComponent implements OnChanges, OnInit {
  @HostBinding('class')
  private readonly classes = 'inline-block';

  readonly controlLabelMapping: Record<string, string> = {
    '=1': this.buildTranslationKey('control'),
    other: this.buildTranslationKey('controls'),
  };

  tooltipPlacement: PlacementArray;

  numberOfControls: number;

  linkedFrameworks: string[];

  @Input({ required: true })
  requirement: RequirementResponse;

  constructor(
    @Inject(IS_MOBILE_TOKEN) readonly isMobile: boolean,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('requirement' in changes) {
      this.numberOfControls = Object.values(this.requirement.linked_frameworks)
        .reduce((total, controls) => total + controls.length, 0);

      this.linkedFrameworks = Object.keys(this.requirement.linked_frameworks);

      if (!changes.requirement.firstChange) {
        this.cd.detectChanges();
      }
    }
  }

  ngOnInit(): void {
    this.tooltipPlacement = this.isMobile
      ? 'bottom bottom-start bottom-end top-start top-end top top-left top-right auto'
      : 'top top-start top-end bottom-start bottom-end auto';
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.controlsLabel.${key}`;
  }
}
